import builder from '../builder';
import VideoPlayerSlider from '../../streamline-icons/bold/video-player-slider.svg';

export default builder('IconVideoPlayerSliderBold', VideoPlayerSlider);
